module.exports = __webpack_public_path__ + "img/3.5dee4dfc.png";